<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <sa-filter-component @submit="onSubmitFarmacie" @reset="resetFiltroFarmacie">
                <b-form style="width: 100%">
                    <b-row class="sa-form-btn-filter">
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Farmacia</label>
                            <input class="sa-page-search-component-input" v-model="filtroFarmacie.farmacia" placeholder="Inserisci farmacia..." />
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Comune</label>
                            <input class="sa-page-search-component-input" v-model="filtroFarmacie.comune" placeholder="Inserisci comune..." />
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Titolare</label>
                            <input class="sa-page-search-component-input" v-model="filtroFarmacie.titolare" placeholder="Inserisci titolare..." />
                        </b-col>
                    </b-row>
                </b-form>
            </sa-filter-component>
        </template>
        <template slot="table-body">
            <farmacie-list-component ref="FarmacieListComponent"></farmacie-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import FarmacieListComponent from "../components/FarmacieListComponent.vue";
import SaFilterComponent from "../../../../template/layout/components/SaFilterComponent.vue";
export default {
    components: { SaPageLayout, FarmacieListComponent, SaFilterComponent },
    data() {
        return {
            filtroFarmacie: {
                farmacia: null,
                comune: null,
                titolare: null,
            },
            btnNewVisible: true,
            pathResource: "",
            linkedit: "/farmacie",
            showModalLoading: false,
            cont: 0,
        };
    },
    mounted() {
        let me = this;
        if (sessionStorage["filtroFarmacie"]) {
            me.filtroFarmacie = JSON.parse(sessionStorage["filtroFarmacie"]);
        }
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            //     me.showModalLoading = true;
            me.$refs.FarmacieListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        /*   onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        }, */
        onSubmitFarmacie() {
            let me = this;
            sessionStorage["filtroFarmacie"] = JSON.stringify(me.filtroFarmacie);
            me.$refs.FarmacieListComponent.loadData();
        },
        resetFiltroFarmacie() {
            let me = this;
            me.filtroFarmacie = {
                farmacia: null,
                comune: null,
                titolare: null,
            };
            sessionStorage["filtroFarmacie"] = JSON.stringify(me.filtroFarmacie);
            this.loadData();
        },
    },
};
</script>

<style></style>
